/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TopMenuSeparatorController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class TopMenuSeparatorController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class TopMenuSeparatorController extends cls.ControllerBase /** @lends classes.TopMenuSeparatorController.prototype */ {
    static __name = "TopMenuSeparatorController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.HiddenVMBehavior);
    }
  }

  cls.TopMenuSeparatorController = TopMenuSeparatorController;
  cls.ControllerFactory.register("TopMenuSeparator", cls.TopMenuSeparatorController);
});
